<div class="ap-menu">
    <a *ngFor="let menu of menuItems | async" [routerLink]="['./', menu.url]" routerLinkActive="ap-active"
        [class.ap-sub-link-active]="menu.url === currentMenu?.parentUrl" class="ap-menu-link ap-ml-2">
        {{ menu.name }}
    </a>
</div>
<div class="ap-menu-txt">
    <a href="tel:{{'properties.claimsEnquiryPhone' | content}}">
        <span class="ap-phone-logo"></span>
        {{'properties.generalEnquiryPhone' | content}}
    </a>
</div>